/**
 * Accessible Accordion (Native <details> version)
 * Adds .is-expanded class for styling when open
 */
document.addEventListener('DOMContentLoaded', function () {
	const accordions = document.querySelectorAll('.accordion');

	accordions.forEach(function (accordion) {
		const details = accordion.querySelectorAll('details');
		details.forEach(function (detail) {
			detail.addEventListener('toggle', function () {
				if (detail.open) {
					detail.classList.add('is-expanded');
				} else {
					detail.classList.remove('is-expanded');
				}
			});
			// Set initial state
			if (detail.open) {
				detail.classList.add('is-expanded');
			}
		});
	});
}); 